import React from "react";

import {
  Separator,
  Stack,
  useTheme,
  IChoiceGroupOption,
  ChoiceGroup,
  Heading,
  Toggle,
  TextField
} from "@bps/fluent-ui";
import { PracticeLocation } from "@libs/api/gateways/best-health/practice/best-health-ops-gateway.dtos";

const toggleStyles = {
  root: {
    marginBottom: 0
  }
};

interface PracticeLocationConfigProps {
  location: PracticeLocation;
}
export const PracticeLocationConfig: React.FC<PracticeLocationConfigProps> = ({
  location
}) => {
  enum PatientRecordConfig {
    CreateOther = "0",
    CreateNewPatient = "1",
    Block = "2"
  }

  const options: IChoiceGroupOption[] = [
    {
      key: PatientRecordConfig.CreateOther,
      text: "Create an 'Other' appointment type"
    },
    {
      key: PatientRecordConfig.CreateNewPatient,
      text: "Create a draft patient record"
    },
    {
      key: PatientRecordConfig.Block,
      text: "Prevent patients from booking online"
    }
  ];

  const theme = useTheme();
  return (
    <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
      <Stack
        horizontal
        horizontalAlign="space-between"
        tokens={{
          childrenGap: theme.spacing.l2
        }}
      >
        <Stack.Item>
          <Toggle
            label="Online Bookings Enabled"
            checked={location.bookingSettings.enabled}
            styles={toggleStyles}
            disabled={true}
          />

          <Toggle
            label="Create Patient Record"
            checked={location.createNewPatientRecord}
            styles={toggleStyles}
            disabled={true}
          />
        </Stack.Item>
        <Separator vertical />
        <Stack.Item>
          <Toggle
            label="Allow Cancel"
            checked={location.allowCancellationsEnabled}
            styles={toggleStyles}
            disabled={true}
          />

          <TextField
            label="Min Time To Book"
            value={location.minimumTimeToBook?.toString()}
            onChange={() => {}}
            disabled={true}
          />
        </Stack.Item>
        <Separator vertical />
        <Stack.Item>
          <TextField
            label="Max Appts Per Day"
            value={location.maximumAppointmentsPerDay?.toString()}
            disabled={true}
            onChange={() => {}}
          />
          <TextField
            label="Weeks in Advance"
            value={location.showAvailability?.toString()}
            disabled={true}
            onChange={() => {}}
          />
        </Stack.Item>
      </Stack>
      <Stack
        horizontal
        horizontalAlign="space-between"
        tokens={{
          childrenGap: theme.spacing.l2
        }}
      >
        <Stack.Item>
          <Heading styles={{ root: { marginBottom: 8 } }}>
            Patient matching configuration:
          </Heading>
          <ChoiceGroup
            disabled={true}
            selectedKey={location.patientRecordConfig.toString()}
            name="patientRecordConfig"
            options={options}
            data-test="unmatched-patient-record-configuration"
          />
        </Stack.Item>
      </Stack>
    </Stack>
  );
};
